import "es6-promise/auto";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/logiall-plugin";
import "./plugins/validCheck";
import VueGtag from "vue-gtag";
import VueMeta from "vue-meta";
import VueHead from "vue-head";

Vue.config.productionTip = false;

Vue.use(VueHead);
Vue.use(
  VueGtag,
  {
    config: {
      id: process.env.VUE_APP_Google,
    },
  },
  router
);

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

new Vue({
  VueHead,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
